import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconProjectRemoved = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M19 12V8.7241C19 8.25623 18.836 7.80316 18.5364 7.44373L14.5997 2.71963C14.2197 2.26365 13.6568 2 13.0633 2H11H7C4.79086 2 3 3.79086 3 6V18C3 20.2091 4.79086 22 7 22H12"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16.8787 21.1213L21.1213 16.8787"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8787 16.8787L21.1213 21.1213"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 2.5V6C14 7.10457 14.8954 8 16 8H18.5"
      stroke="#FF3333"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
)
